// extracted by mini-css-extract-plugin
module.exports = {"v-application":"Datepicker_v-application_3T7Kp","text-h1":"Datepicker_text-h1_2VzFx","text-h2":"Datepicker_text-h2_1B-Hk","menu":"Datepicker_menu_3oOdx"};